import React, { useState } from 'react';
import AlertMessage from '../../components/alertMessage/AlertMessage';
import firebase from '../../components/firebase/Firebase'
import logo from './assets/logo-1.png'

import './Auth.css'

const Registrieren = (props) => {
    const [email, setEmail] = useState("");
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [error, setError] = useState("");

    const register = (e) => {
        e.preventDefault()
        if (error) {
            return   
        }
        console.log(email, password)

        if (!email.trim()) {
            setError("Bitte geben Sie eine E-Mail-Adresse ein")
            return
        }

        if (!firstName.trim() || !lastName.trim()) {
            setError("Bitte geben Sie Ihren Vor- und Nachnamen ein")
            return
        }

        if (password !== confirmPassword) {
            setError("Das Bestätigungspasswort stimmt nicht mit Ihrem Passwort überein")
            return
        }

        firebase.auth().createUserWithEmailAndPassword(email.trim(), password).then(user => {
            firebase.database().ref('users/' + user.user.uid).set({
                email,
                name: firstName.trim() + " " + lastName.trim()
            }).then(() => {
                props.history.push('/')
            }).catch(err => {
                setError(err.message)
            })
        }).catch(err => {
            console.log(err)
            switch (err.code) {
                case "auth/email-already-in-use":
                    setError("Die E-Mail-Adresse wird bereits von einem anderen Benutzer verwendet")
                    break;
                case "auth/invalid-email":
                    setError("Die E-Mail-Adresse ist ungültig")
                    break;
                case "auth/weak-password":
                    setError("Das von Ihnen gewählte Passwort ist zu schwach, bitte wählen Sie ein sicheres Passwort")
                    break;
                default:
                    break;
            }
        })
    }

    return (
        <div className="register-wrapper" onSubmit={register}>
            <AlertMessage isOpen={error} message={error} type={"ERROR"} onClose={() => {console.log("closing"); setError("")}} />
            <div className="register-container">
                <img src={logo} alt="logo" />
                <h1>Neues Konto registrieren</h1>
                <input className="primary" type="text" name="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="E-Mail-Adresse" />
                <input className="primary" type="text" name="firstName" value={firstName} onChange={(e) => setFirstName(e.target.value)} placeholder="Vorname" />
                <input className="primary" type="text" name="lastName" value={lastName} onChange={(e) => setLastName(e.target.value)} placeholder="Nachname" />
                <input className="primary" type="password" name="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Passwort eingeben" />
                <input className="primary" type="password" name="confirmPassword" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} placeholder="Passwort bestätigen" />
                <button className="primary blue-button" onClick={register}>Registrieren</button>
                <h2>Bereits registriert?</h2>
                <button className="primary" onClick={() => props.history.push('login')}>Anmelden</button>
            </div>
        </div>
    );
}
 
export default Registrieren;